import React, { useEffect, useState } from "react";
import AppLayout from "@/components/layout/AppLayout";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import { Bell, Droplets, Package, ShoppingCart, ShieldAlert, Wrench, AlertOctagon } from "lucide-react";

const ICONS = { lubrication: Droplets, inventory: Package, purchase_requisition: ShoppingCart, permit: ShieldAlert, job_order: Wrench, breakdown: AlertOctagon };
const SEV = { high: "border-red-300 bg-red-50 text-red-700", medium: "border-amber-300 bg-amber-50 text-amber-700", low: "border-slate-200 bg-slate-50 text-slate-600" };

export default function Notifications() {
  const [notes, setNotes] = useState([]);
  useEffect(() => { api.get("/notifications").then((r) => setNotes(r.data.notifications || [])); }, []);

  return (
    <AppLayout title="Notification Centre" subtitle="Alerts across all modules — lubrication, inventory, permits, maintenance & safety">
      <Card className="p-4" data-testid="notifications-page">
        {!notes.length && <div className="text-center py-16 text-slate-400" data-testid="notifications-empty">No active notifications — all clear.</div>}
        <div className="space-y-2">
          {notes.map((n, i) => {
            const Icon = ICONS[n.module] || Bell;
            return (
              <div key={i} className={`flex items-center gap-3 rounded-md border px-4 py-3 ${SEV[n.severity] || SEV.low}`} data-testid={`notification-item-${i}`}>
                <Icon className="h-4 w-4 shrink-0" />
                <div className="flex-1 text-sm text-slate-700">{n.message}</div>
                <span className="text-[10px] uppercase tracking-wider font-semibold">{n.severity}</span>
              </div>
            );
          })}
        </div>
      </Card>
    </AppLayout>
  );
}
